import Vue from 'vue';
import can from '@/plugins/can';
export default (function (_a) {
    var store = _a.store;
    Vue.prototype.$can = function (resource, action, options) {
        return can(store.getters['initial-setting/company'], resource, action, options);
    };
});
